import { render, staticRenderFns } from "./nav-bar-item.vue?vue&type=template&id=0e35525c&scoped=true&"
import script from "./nav-bar-item.vue?vue&type=script&lang=js&"
export * from "./nav-bar-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35525c",
  null
  
)

export default component.exports